<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="75%" @open="addOpen" :close-on-click-modal="false">
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
         <el-select v-model="param.status" placeholder="请选择状态" filterable @change="search">
            <el-option label="请选择状态" :value="0"></el-option>
            <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="param.labels" multiple filterable placeholder="请选择标签" @change="search" style="width: 300px;">
            <el-option label="请选择标签" :value="0"></el-option>
            <el-option v-for="item in labelList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入邮箱" v-model="param.keyword" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
         <el-select v-model="param.mailgun_id" placeholder="请选择发件域名">
            <el-option label="请选择发件域名" :value="0"></el-option>
            <el-option v-for="item in mailgunList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="sendMail" :disabled="isSending === 1">{{sendTxt}}</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" @selection-change="handleSelectionChange" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column type="selection" width="40" align="center"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.status | getStatusTitle(statusList)}}
          </template>
        </el-table-column>
        <el-table-column label="标签" align="center">
          <template slot-scope="scope">
            <el-tag size="small" v-for="item in scope.row.labels" :key="item.id" style="margin-right: 5px;">{{item.title}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发送状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.is_send === 1">已发送</el-tag>
            <el-tag type="info" v-else>未发送</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </el-dialog>
</template>

<script>
export default {
  name: 'ghost_send_mail',
  props: [
    'visible', 'id', 'labelList', 'mailgunList'
  ],
  data () {
    return {
      title: '发送邮件',
      isSending: 0,
      sendTxt: '发送',
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        gh_post_id: '',
        keyword: '',
        status: 20,
        labels: [],
        mailgun_id: 0,
        sub_ids: [],
        page: 1,
        count: 10
      },
      statusList: [
        { id: 10, title: '未订阅' },
        { id: 20, title: '订阅' },
        { id: 40, title: '拒绝' }
      ]
    }
  },
  filters: {
    getStatusTitle (id, statusList) {
      for (var i = 0; i < statusList.length; i++) {
        if (statusList[i].id === id) {
          return statusList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    closeDialog () {
      this.param = {
        gh_post_id: '',
        keyword: '',
        status: 20,
        labels: [],
        mailgun_id: 0,
        sub_ids: [],
        page: 1,
        count: 10
      }
      this.$emit('closeDialog')
    },
    addOpen () {
      this.param.gh_post_id = this.id
      this.getList()
    },
    handleSelectionChange (val) {
      this.param.sub_ids = []
      val.forEach(row => {
        this.param.sub_ids.push(row.id)
      })
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    async getList () {
      const res = await this.$http.get('/admin/subscribe/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    async sendMail () {
      if (this.param.mailgun_id === 0) {
        this.$message.error('请选择发送域名')
        return
      }

      if (this.param.labels.length === 0 && this.param.sub_ids.length === 0) {
        this.$message.error('必须选择标签或者具体邮箱，才能发送邮件！！！')
        return
      }

      this.$confirm('确定要发送邮件，如果没有选择具体邮箱，将发送列表里的所有邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.sendTxt = '发送中...'
        this.isSending = 1
        const res = await this.$http.post('/admin/ghost_post/mail_send', this.param)
        this.sendTxt = '发送'
        this.isSending = 0
        if (res.code === 0) {
          this.$message.success('发送成功')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
